module.exports = __webpack_public_path__ + "static/kevin-ab216014f2967f1d956d3969be7ce4f4.jpg";